export * from './fitter-infos-box.component';
